<script>
    import {
        NotificationModal,
        RichTextEditor,
    } from "../../../Components/Common/index.svelte";

    export let notificationObj = {},
        type = "",
        isModalOpen = false,
        isCreatingNotification = false,
        closeModal = () => {},
        createNotification = () => {};

    $: isTypeSMS = type && type.toLowerCase() == "sms";

    $: isTypeEmail = type && type.toLowerCase() == "email";
</script>

{#if isModalOpen}
    <NotificationModal
        {isModalOpen}
        title="Send a New {type.toUpperCase()}"
        cancelText="Cancel"
        {closeModal}
        closeModalFunction={closeModal}
        submitText={isCreatingNotification ? "Sending" : "Send"}
        isConfirmDisabled={isCreatingNotification}
        isConfirming={isCreatingNotification}
        confirmAction={createNotification}
        noContentPadding
        modalMaxWidth={isTypeEmail ? "max-w-6xl" : ""}
    >
        <div class="flex flex-1 flex-col gap-y-4 relative overflow-y-auto p-6">
            {#if isTypeEmail}
                <div class="flex gap-x-4 items-center">
                    <p class="w-24">Subject:</p>
                    <input
                        type="text"
                        class="input input-bordered input-sm flex-1"
                        autocomplete="off"
                        bind:value={notificationObj.subject}
                    />
                </div>
            {/if}

            {#if isTypeSMS}
                <textarea
                    cols="30"
                    rows="5"
                    bind:value={notificationObj.content}
                    class="textarea w-full textarea-bordered"
                    placeholder="SMS content"
                    autocomplete="off"
                />
            {:else if isTypeEmail}
                <RichTextEditor
                    bind:content={notificationObj.content}
                    config={{ placeholder: "Email content" }}
                />
            {/if}
        </div>
    </NotificationModal>
{/if}
